module.exports = __webpack_public_path__ + "assets/img/menu_recommend.6f296fd4.png";